import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  formHelperTextSuccess: {
    color: theme.palette.success.main,
  },
}));
